import './styles/main.scss';

import './scripts/vendor/jquery.fancybox.js';

import './scripts/custom.js';
import './scripts/qna-filter.js';